module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": _vm.closeTransition ? '' : 'el-zoom-in-center'
    }
  }, [_c('span', {
    staticClass: "el-tag",
    class: [_vm.type ? 'el-tag--' + _vm.type : '', {
      'is-hit': _vm.hit
    }],
    style: ({
      backgroundColor: _vm.color
    })
  }, [_vm._t("default"), _vm._v(" "), (_vm.closable) ? _c('i', {
    staticClass: "el-tag__close el-icon-close",
    on: {
      "click": _vm.handleClose
    }
  }) : _vm._e()], 2)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-6715304f", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/.12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-6715304f","hasScoped":false}!./~/.12.2.2@vue-loader/lib/selector.js?type=template&index=0!./~/.1.4.12@element-ui/packages/tag/src/tag.vue
// module id = 18
// module chunks = 0